// extracted by mini-css-extract-plugin
export default {"carousel-coverflow":"YU9Cb_XpZ5bnvQD2MANO","carouselCoverflow":"YU9Cb_XpZ5bnvQD2MANO"};